Wee.fn.make('changeView', {
	init: function() {
		var priv = this.$private;

		priv.changeView();
	},

	unload: function() {
		Wee.events.off(false, '.changeView');
	}
}, {
	changeView: function() {
		$('ref:view').on('click.changeView', function(e, el) {
			var $el = $(el),
				sourceSet = $el.attr('srcset'),
				sourceUrl = $el.data('url');

			$('ref:productImage').attr('src', sourceUrl);
			$('ref:productImage').attr('srcset', sourceSet);
		});
	}
});